import React from "react";

const Loader = () => {
    return <div className="p-4">Loading…</div>
};
export default Loader;